import { render, staticRenderFns } from "./VVRangeDatepickerDialog.vue?vue&type=template&id=38711a5c&scoped=true"
import script from "./VVRangeDatepickerDialog.vue?vue&type=script&lang=js"
export * from "./VVRangeDatepickerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38711a5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38711a5c')) {
      api.createRecord('38711a5c', component.options)
    } else {
      api.reload('38711a5c', component.options)
    }
    module.hot.accept("./VVRangeDatepickerDialog.vue?vue&type=template&id=38711a5c&scoped=true", function () {
      api.rerender('38711a5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/VVRangeDatepickerDialog.vue"
export default component.exports